import React from 'react';
import { Fab, useApiClient, useFetch } from '@marageti/z4-lib';
import { LoadingButton } from '@mui/lab';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Stack } from '@mui/material';
import { TripRequest, TripRequestStatus } from '@marageti/z4-sdk/lib/travel';
import { useMatchingStore } from '../../../store';

const Footer = () => {
  const { pathname } = useLocation();
  const { tripRequestId } = useParams();
  const apiClient = useApiClient();
  const isConfirmationPage = pathname.includes('confirm-match');
  const navigate = useNavigate();
  const {
    isLoading,
    onClickConfirmMatches,
    selectedMatches,
  } = useMatchingStore();
  const numberOfSelectedPartners = Object.keys(selectedMatches).length;

  const { data: tripRequest } = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripRequestId], !!tripRequestId);

  const onClickNext = () => {
    navigate('./confirm-match', { replace: true });
  };

  return (
    <Fab anchorId="oryx-footer">
      <Stack
        direction={{ desktop: 'row' }}
        spacing={2}
        sx={{ width: { mobile: '100%', desktop: 'fit-content' }, px: 3 }}
      >
        <LoadingButton
          disabled={numberOfSelectedPartners === 0 || tripRequest?.status === TripRequestStatus.PendingStatus}
          loading={isLoading}
          onClick={isConfirmationPage ? onClickConfirmMatches : onClickNext}
          sx={isConfirmationPage ? undefined : { borderColor: (theme) => theme.palette.divider }}
          variant={isConfirmationPage ? 'contained' : 'outlined'}
        >
          {isConfirmationPage ? 'Confirm Match' : `Next (${numberOfSelectedPartners} Selected)`}
        </LoadingButton>
        {isConfirmationPage && (
        <Button
          variant="outlined"
          onClick={() => navigate('./match')}
          sx={{ mt: { mobile: 2, desktop: 0 } }}
        >
          Change Matches
        </Button>
        )}
      </Stack>
    </Fab>
  );
};

export default Footer;
